import { render, staticRenderFns } from "./Register.html?vue&type=template&id=5a69511d&scoped=true&"
import script from "./Register.ts?vue&type=script&lang=ts&"
export * from "./Register.ts?vue&type=script&lang=ts&"
import style0 from "./Register.scss?vue&type=style&index=0&id=5a69511d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a69511d",
  null
  
)

export default component.exports